import classNames from 'classnames'

import Icon from 'components/uiKit/Icon'
import { KitSize } from 'components/uiKit/KitTypes'
import { Typography } from 'components/uiKit/Typography'

import * as s from './FileUsageComponent.module.scss'
import { FlattenUsageState } from './types'

interface IFileUsageProps {
  usage: FlattenUsageState
  gap?: boolean
}

const FileUsage: React.FC<IFileUsageProps> = ({ usage, gap }) => {
  return (
    <div className={classNames(s.usageRow, { [s.gap]: gap })}>
      {usage.icon ? (
        <Icon name={usage.icon} size={KitSize.S} />
      ) : (
        <div className={s.circleWrapper}>
          <svg height='7' viewBox='0 0 7 7' width='7'>
            <circle cx='3.5' cy='3.5' fill='none' r='3' stroke='currentColor' />
          </svg>
        </div>
      )}
      <Typography rows={2} styleType='hint'>
        {usage.name}
      </Typography>
    </div>
  )
}

export default FileUsage
